import { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  childCategories,
  deleteChildCategory,
} from "../../../actions/childCategory";
import { createSearchParams } from "react-router-dom";
import { Pagination } from "@mui/material";
import TopBarProgress from "react-topbar-progress-indicator";
import moment from "moment";
import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import DeleteConfirmationDialog, {
  confirmButtonType,
} from "../../../components/dialog-boxes/delete-confirmation-dialog";

const ChildCategories = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Local State
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [searchFilter, setSearchFillter] = useState({
    searchQuery: "",
  });

  // Api calls for get Order
  const getCategories = useCallback(
    async (pageNo, search) => {
      const res = await dispatch(childCategories(pageNo, search));
      setData(res?.categories);
      setpagination({
        ...res?.pagination,
      });
      setloading(false);
    },
    [dispatch]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }
  }, [location.search]);

  useEffect(() => {

    var isSubscribe = true;
    if (isSubscribe) {
      var timer = setTimeout(() => {
        getCategories(pagination.currentPage, searchFilter?.searchQuery);
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFilter?.searchQuery, pagination.currentPage]);

  // Reset pagination to page 1 and sync URL
  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: "/admin/child-categories",
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  //Delete Category
  const deleteCategory = async (id) => {
    setloading(true);
    const res = await dispatch(deleteChildCategory(id));
    if (res) {
      setdeleteConfirm({
        open: false,
        id: null,
      });
      const updateFormData = data?.filter((item) => item?._id !== id);
      setData(updateFormData);
      setloading(false);
    }
  };

  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div className="d-flex justify-content-end align-center">
            <SearchFilter
              type="text"
              placeholder={"Search Child Categories"}
              value={searchFilter?.searchQuery}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFillter({
                  ...searchFilter,
                  searchQuery: e.target.value,
                });
              }}
            />
          </div>
          <div className="my-5">
            <DashboardPagesLayout
              pageTitle="Child Categories"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="dashboard-pages-table">
                <table className="mt-5">
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Image</th>
                      <th>Parent</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length ? (
                      <>
                        {data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${item?._id}`)
                              }
                            >
                              {i + 1}
                            </td>
                            <td>{item.name}</td>
                            <td>
                              {item.status ? (
                                <span className="text-success">Enable</span>
                              ) : (
                                <span className="text-danger">Disable</span>
                              )}
                            </td>

                            <td>
                              <img
                                src={item.image}
                                height="50px"
                                width="50px"
                                alt="item"
                              />
                            </td>
                            <td>
                              {item.maincategory &&
                                item.maincategory.length > 0 &&
                                item.maincategory[0].name}{" "}
                            </td>
                            <td>{moment(item?.createdAt).format("l")}</td>
                            <td>
                              <CustomeTableBtn
                                color="secondary"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() =>
                                  navigate(
                                    `/admin/edit-child-category/?id=${item._id}`
                                  )
                                }
                              >
                                Edit
                              </CustomeTableBtn>

                              <CustomeTableBtn
                                color="danger"
                                width={"100px"}
                                onClick={() =>
                                  setdeleteConfirm({
                                    open: true,
                                    id: item?._id,
                                  })
                                }
                              >
                                Delete
                              </CustomeTableBtn>

                              {deleteConfirm.open && (
                                <DeleteConfirmationDialog
                                  show={true}
                                  message="Are you sure you want to delete?"
                                  onCancel={() =>
                                    setdeleteConfirm({ open: false, id: null })
                                  }
                                  title="Are you sure?"
                                  confirmBtnBsStyle={confirmButtonType.Danger}
                                  onConfirm={(e) => {
                                    deleteCategory(deleteConfirm?.id);
                                  }}
                                  focusCancelBtn={true}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center align-center p-2">
                  <div className="mx-auto">
                    <Pagination
                      count={pagination.totalPages}
                      page={pagination.currentPage}
                      onChange={handleChange}
                    />
                  </div>

                  <span
                    className="font-weight-bold"
                    style={{ color: "#9f9f9f" }}
                  >
                    {data?.length} of {pagination?.count} Items
                  </span>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default ChildCategories;
